import { handleApiError } from "../error"
import { ClientActivity, IOmniaShell } from "../shell"
import { IUibModalScope } from "../types"
import { isFunction } from "../utils/utils"
import { Component } from "./component"

/// <reference path="./component.ts" />

export class Dialog extends Component {

    private modalScope: IUibModalScope;
    protected arguments: any;

    protected form: ng.IFormController;
    protected showValidationErrors: boolean;

    constructor(protected $scope: ng.IScope, protected shell: IOmniaShell) {

        super($scope);

        const modal = checkModalScope($scope)

        if (modal) {
            this.modalScope = modal.modalScope
            this.arguments = this.execArguments = modal.arguments
        }

    }

    protected dispose() {
        // NOP
    }

    isDialog() {
        return !!this.modalScope;
    }

    cancel() {
        this.close(0);
    }

    closeComponent(result?: any) {

        if (this.isDialog()) {
            this.modalScope.$close(result);
        }
        else {
            this.componentContext.close(result);
        }
    }

    close(returnValue: any) {
        return this.closeComponent(returnValue);
    }

    handleApiError(response: { status: number, data: string }, msg?: string) {
        return handleApiError(this.shell, response, { defaultMessage: msg })
    }

    setActivity(activity: ClientActivity) {

        const m = this.modalScope?.$parent
        if (m) {
            m["omnia:activity"] = activity
        }

        super.setActivity(activity)
    }

}

export function checkModalScope($scope: ng.IScope) {

    const modalScope = <IUibModalScope>($scope.$parent);

    if (modalScope && isFunction(modalScope.$close)) {

        const parent = modalScope.$parent;

        if (parent) {

            return {
                modalScope,
                arguments: parent["arguments"],
                close: modalScope.$close
            }

        }

    }

}
